// BE SURE TO SECURE page component
///*******************************************************************
//*******************************************************************
//IMPORTS:
//EXTERNAL & PACKAGE
import $ from 'jquery'
import Popper from 'popper.js'
import React from 'react'
import {graphql, Link} from 'gatsby'
//COMPONENT DEPENDENCIES
import Heading from '../../components/heading'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import PageHeader from '../../components/PageHeader'
import FullWidthImage from '../../components/FullWidthImage'
import Header from '../../components/Header'
import TextBlock from '../../components/textblock'
import ContentBlock from '../../components/ContentBlock'
import TableOfContents from '../../components/TableOfContents'
import ContentsTable from '../../components/ContentsTable'
import Helmet from "react-helmet"
//*******************************************************************
//*******************************************************************  
const besuretosecurePage = ({data}) => {
    
    const besuretoSecure = data.be_sure_to_secure.edges
    
    const socialEngineeringReport = data.social_engineering_report.edges
        
    const cyberSafetyReport = data.cyber_safety_report.edges
    
    const aiReport = data.ai_iot_and_cryptography_report.edges

    const sEReportTable = []
        
    const cSReportTable = []
    
    const aiReportTable = []

    for (var i = 0; i < socialEngineeringReport.length; i++) {
            
        sEReportTable.push(socialEngineeringReport[i]);

    };
        
    for (var i = 0; i < cyberSafetyReport.length; i++) {
            
        cSReportTable.push(cyberSafetyReport[i]);

    };
    
    for (var i = 0; i < aiReport.length; i++) {
            
        aiReportTable.push(aiReport[i]);

    };

    
    return (
        
        <div>
        
            
            <Helmet>
            <title>NJCCIC Be Sure To Secure</title>
            <meta name="description" content="We provide informational reports on various cybersecurity and technical topics to assist users in bolstering the security of their devices, data, and networks"/>
            </Helmet>
            <Heading/>

            <Navbar/>

            {besuretoSecure.map(({ node: {page_title, introductory_text, image, content_group} }) => (

                <div class="container-fluid">

                    <PageHeader elementClass="pageHeader centerText" title={page_title}/>
        
                    <div class="container containerWidth">
                        
                        <div class="row">

                            <TextBlock elementClass="standardText introPadding" text={introductory_text}/>  
                            
                        </div>
                        
                    </div>
        
                    <ContentsTable testClass="testClass container containerWidth grid2Container" elementClass="col-12 col-sm-6 col-md-4 grid2 blocks block2 block2Alt" dangerousClass="standardText blockText margin btnWidth" headerStyles="header contentTitle" data={content_group} iconId="iconsGroup"/>
                    
                    <FullWidthImage id="bitsBanner" src={image}/>
        
                </div>

            ))}
            
            <div class="container-fluid">

                <div class="container containerWidth">
                        
                    <Header styles="header contentTitle guideTitle" title="Social Engineering Reports" id="social-engineering-reports"/>
                        
                    <div class="row">
                        
                        {sEReportTable.map(({ node }) => {

                            const postTitle = node.seo_title || node.slug

                            return (

                                <div class="col-12 col-sm-6 offset-sm-0 col-md-4 articleFeature" key={node.slug}>
                                        
                                    <img src={node.featured_image}></img>
                                    <h3 class="header leftHeader clickableHeader postHeader articleName"><Link to={`/informational-report/${node.slug}`}>{postTitle}</Link></h3>
                                    <p>{node.summary}</p>
                                    <p class="fontWeight"><Link to={`/informational-report/${node.slug}`}>CONTINUE READING > </Link></p>

                                </div>
                                
                            )

                        })} 
                        
                    </div>
                    
                    <Header styles="header contentTitle guideTitle" title="Cyber Safety Reports" id="cyber-safety-reports"/>
                    
                    <div class="row">
                        
                        {cSReportTable.map(({ node }) => {

                            const postTitle = node.seo_title || node.slug

                            return (

                                <div class="col-12 col-sm-6 offset-sm-0 col-md-4 articleFeature" key={node.slug}>
                                        
                                    <img src={node.featured_image}></img>
                                    <h3 class="header leftHeader clickableHeader postHeader articleName"><Link to={`/informational-report/${node.slug}`}>{postTitle}</Link></h3>
                                    <p>{node.summary}</p>
                                    <p class="fontWeight"><Link to={`/informational-report/${node.slug}`}>CONTINUE READING > </Link></p>

                                </div>
                                
                            )

                        })}
                    
                    </div>
                    
                    <Header styles="header contentTitle guideTitle" title="AI, IoT, and Cryptography Reports" id="ai-iot-and-cryptography-reports"/>
                    
                    <div class="row">
                        
                        {aiReportTable.map(({ node }) => {

                            const postTitle = node.seo_title || node.slug

                            return (

                                <div class="col-12 col-sm-6 offset-sm-0 col-md-4 articleFeature" key={node.slug}>
                                        
                                    <img src={node.featured_image}></img>
                                    <h3 class="header leftHeader clickableHeader postHeader articleName"><Link to={`/informational-report/${node.slug}`}>{postTitle}</Link></h3>
                                    <p>{node.summary}</p>
                                    <p class="fontWeight"><Link to={`/informational-report/${node.slug}`}>CONTINUE READING > </Link></p>

                                </div>
                                
                            )

                        })}
                            
                    </div>
                    
                </div>
                
            </div>

            <Footer/>

        </div>
    
    )
    
}
//*******************************************************************  
export const query = graphql`
    query {
        be_sure_to_secure: allButterPage(filter: {slug: { eq: "be-sure-to-secure" } }) {
            edges {
                node {
                    slug
                    page_title
                    introductory_text
                    image
                    content_group {
                        section_name
                        text
                        icon
                    }
                }
            }
            
        }
        social_engineering_report: allButterPost(filter: {categories: {elemMatch: {name: {eq: "Social-Engineering-Report"}}}}) {
            edges {
                node {
                    id
                    seo_title
                    meta_description
                    slug
                    categories {
                        name
                        slug
                    }
                    tags {
                        name
                        slug
                    }
                    date
                    summary
                    author {
                        first_name
                        last_name
                        email
                        slug
                        bio
                        title
                        linkedin_url
                        facebook_url
                        instagram_url
                        pinterest_url
                        twitter_handle
                        profile_image
                    }
                    body
                    featured_image
                }
            }
        }
        cyber_safety_report: allButterPost(filter: {categories: {elemMatch: {name: {eq: "Cyber-Safety-Report"}}}}) {
            edges {
                node {
                    id
                    seo_title
                    meta_description
                    slug
                    categories {
                        name
                        slug
                    }
                    tags {
                        name
                        slug
                    }
                    date
                    summary
                    author {
                        first_name
                        last_name
                        email
                        slug
                        bio
                        title
                        linkedin_url
                        facebook_url
                        instagram_url
                        pinterest_url
                        twitter_handle
                        profile_image
                    }
                    body
                    featured_image
                }
            }
        }   
        ai_iot_and_cryptography_report: allButterPost(filter: {categories: {elemMatch: {name: {eq: "AI-IoT-and-Cryptography-Report"}}}}) {
            edges {
                node {
                    id
                    seo_title
                    meta_description
                    slug
                    categories {
                        name
                        slug
                    }
                    tags {
                        name
                        slug
                    }
                    date
                    summary
                    author {
                        first_name
                        last_name
                        email
                        slug
                        bio
                        title
                        linkedin_url
                        facebook_url
                        instagram_url
                        pinterest_url
                        twitter_handle
                        profile_image
                    }
                    body
                    featured_image
                }
            }
        }
    }
`
//*******************************************************************  
export default besuretosecurePage

